'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefArrow = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefArrow = exports.DefArrow = function DefArrow(_ref) {
  var expanded = _ref.expanded,
      disabled = _ref.disabled;
  return _react2.default.createElement(
    'div',
    { className: 'Header__arrow' },
    _react2.default.createElement('div', {
      className: (0, _utils.classes)({
        'Header__arrow--down': !expanded,
        'Header__arrow--up': expanded,
        'Header__arrow--active': !disabled && expanded,
        'Header__arrow--disabled': disabled
      })
    })
  );
};